<template>
  <div class="left-side-menu" :class="{ 'light-variation': isLeadMachine }">
    <div class="sidebar-content mt-3">
      <router-link
      v-if="config && ((routeName.startsWith('business.') || routeName.startsWith('agency.')) || config.logo)"
      class="navbar-brand ml-3 mr-0 mr-md-2 logo"
      :to="(userRole === 'Business' && isOnAgencyRoute) ? '/agency' : ('/' + userRole.toLocaleLowerCase())"
    >
      <!-- <span class="logo-lg">
        <img v-if="config.logo" :src="config.logo" style="display:block;margin:auto;max-width:210px;max-height:50px;"/>
        <img v-else-if="origin === 'https://app.showmyrep.io' || origin.includes('rvrply.com') || origin.includes('reviewour.biz')" src="@assets/images/Blank.png" alt width="210" />
        <img v-else-if="origin.includes('tapengine.io')" src="@assets/images/tapengine-logo.png" style="display:block;margin:auto;height:40px;max-width:100%;" alt="tapengine"/>
        <img v-else-if="origin.includes('getsocialreviews.com')" src="@assets/images/social-review-logo.png" style="display:block;margin:auto;height:45px;max-width:100%;"/>
        <img v-else-if="origin.includes('reviewsurge.co')" src="@assets/images/review-surge-logo.png" style="display:block;margin:auto;height:40px;max-width:100%;"/>
        <img v-else-if="origin.includes('leadmachine.io')" src="@assets/images/lead-machine-logo.png" style="display:block;margin:auto;height:25px;max-width:100%;"/>
        <img v-else-if="origin.includes('socialfusionai.com')" src="@assets/images/social-fusion-logo.png" style="display:block;margin:auto;height:25px;max-width:100%;"/>
        <img v-else-if="origin.includes('instastream.co')" src="@assets/images/insta-stream-logo.png" style="display:block;margin:auto;height:25px;max-width:100%;"/>
        <img v-else-if="origin.includes('zensocial.io') || isZenSocial" src="@assets/images/zensocial-logo.png" style="display:block;margin:auto;height:45px;max-width:100%;"/>
        <img v-else-if="isRepuAgency || origin.includes('repuagency.com')"
              src="@assets/images/repuagency-logo.png"
              style="display:block;margin:auto;max-width:200px;"
              srcset="@assets/images/repuagency-logo-dark.png 768w, @assets/images/repuagency-logo.png 769w"
        />
        <img v-else src="@assets/images/logo.png" alt height="50" />
      </span> -->
      <div class="flex">
        <span class="logo-sm">
          <img v-if="sidebarBrandLogo" :src="sidebarBrandLogo" alt />
          <img v-else-if="isReputationHub" src="@assets/images/repuagency-favicon.png" alt height="50" />
          <img v-else-if="isRepuAgency" src="@assets/images/repuagency-favicon.png" alt height="50" />
          <img v-else-if="isZenSocial" src="@assets/images/zensocial-favicon.png" alt height="50" />
          <img v-else src="@assets/images/favicon.png" alt height="50" />
        </span>
        <div class="ml-2"
        ><h4 v-if="!sidebarBrandLogo" class="font-weight-bold mt-1 my-0 text-dark">
          {{ displayName }}
          </h4><p class="text-muted-foreground text-sm"
          >{{ isReputationHub ? 'ReputationHub' : 'Reputation Management' }}</p
        ></div
      >
        
      </div>
    </router-link>
      <div id="sidebar-menu">
        <!-- Show team select for Agency and when Business is not on agency route -->
        <template >
          <TeamSelect />
          <hr class="my-3 w-100">
        </template>
        <ul id="side-menu" class="metismenu ">
          <li
              v-for="(menuItem, index) in renderMenuItems"
              :key="index"
              class="side-nav-title side-nav-item"
              :class="{ 'mm-active': currentRoute.match(menuItem.pathActive), 'mm-show': menuItem.isExpanded }"
          >
            <router-link
                v-if="!menuItem.items && menuItem.route"
                :to="{ name: menuItem.route }"
                class="side-nav-link side-nav-link-ref"
                exact-active-class=".side-nav-item"
            >
              <i :class="menuItem.icon" class="uil icon-round"></i>
              <span>{{ menuItem.label }}</span>
            </router-link>

            <a
                v-if="!menuItem.items && menuItem.routeOut"
                :href="menuItem.routeOut"
                class="side-nav-link"
                target="_blank"
            >
              <i :class="menuItem.icon" class="uil"></i>
              <span>{{ menuItem.label }}</span>
            </a>

            <a
                v-if="menuItem.items"
                href="#"
                class="side-nav-link"
                :aria-expanded="menuItem.isExpanded"
                @click.prevent="clickParentItem(menuItem)"
            >
              <i :class="menuItem.icon" class="uil"></i>
              <span>{{ menuItem.label }}</span>
              <span v-if="!currentRoute.match(menuItem.pathActive)" class="menu-arrow"></span>
            </a>
            <ul
                v-if="menuItem.items"
                class="nav-second-level mm-collapse"
                :class="{ 'mm-show': currentRoute.match(menuItem.pathActive) || menuItem.isExpanded }"
            >
              <li v-for="(item, index1) in menuItem.items" :key="index1" :class="{ 'active-child': currentRoute.match(item.pathActive) }">
                <router-link :to="{ name: item.route }">
                  <span>{{ item.label }}</span>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
        <div class="sidebar-bottom mt-auto">
          <hr class="my-3">
          <div v-if="user" class="d-flex align-items-center mx-3 mb-3">
            <img :src="user.avatar" class="avatar-sm rounded-circle mr-2" />
            <div class="text-black">
              <div class="fw-bold">{{ user.full_name }}</div>
              <div class="text-muted small">{{ user.email }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>import TeamSelect from "@layouts/Partials/TeamSelectNew.vue";
export default {
  components: {
    TeamSelect
  },
  data() {
    return {
      sideBarBackground: window.location.origin.includes('leadmachine') ? '#ffffff' : '#1e3260',
      sideBarLinkColor: window.location.origin.includes('leadmachine') ? '#818191' : '#cfd0d0',
      menuRef: null,
      menuItems: {
        Admin: [
          {
            label: 'Agencies',
            icon: 'uil-briefcase',
            pathActive: '/admin/agencies',
            route: 'admin.agencies.index',
            isExpanded:true,
            items: [
              { label: 'List', route: 'admin.agencies.index' },
              { label: 'Archived', route: 'admin.agencies.archived' },
            ],
          },
          {
            label: 'Plans',
            icon: 'uil-atm-card',
            route: 'admin.plans.index',
            pathActive: '/admin/plans',
          },
          {
            label: 'Training',
            icon: 'uil-life-ring',
            route: 'admin.settings.training',
            pathActive: '/admin/training',
          },
          {
            label: 'Emails',
            icon: 'uil-envelope-edit',
            route: 'admin.settings.emails',
            pathActive: '/admin/emails',
          },
          {
            label: 'Settings',
            icon: 'uil-cog',
            route: 'admin.settings.index',
            pathActive: '/admin/settings',
          },
          {
            label: 'Tracking',
            icon: 'uil-truck',
            route: 'admin.tracking.index',
            pathActive: '/admin/tracking',
          },
        ],
        Agency: [
          {
            label: 'Dashboard',
            icon: 'uil-home',
            pathActive: '/agency/dashboard',
            route: 'new-agency.dashboard',
          },
          {
            label: 'Customers',
            route: 'new-agency.customers.index',
            icon: 'uil-user-square',
            pathActive: '/agency/customers',
          },
          {
            label: 'Leads',
            route: 'new-agency.businesses.index',
            icon: 'uil-users-alt',
            pathActive: '/agency/businesses',
          },
          {
            label: 'InstaStream',
            icon: 'uil-instagram',
            pathActive: '/agency/instagram-widget',
            route: 'agency.instagram-widget.index',
          },
          {
            label: 'Landing Page',
            icon: 'uil-web-grid-alt',
            pathActive: '/agency/landing',
            route: 'agency.landing',
          },
          {
            label: 'RE Widget',
            icon: 'uil-code',
            pathActive: '/agency/embed',
            route: 'agency.embed',
          },
          {
            label: 'SR Widget',
            icon: 'uil-code',
            pathActive: '/agency/sr-widget',
            route: 'agency.sr-widget',
          },
          {
            label: 'SF Widget',
            icon: 'uil-code',
            pathActive: '/agency/sf-widget',
            route: 'agency.sf-widget',
          },
          {
            label: 'IS Widget',
            icon: 'uil-code',
            pathActive: '/agency/is-widget',
            route: 'agency.insta-stream-widget',
          },
          {
            label: 'Lead Machine',
            route:'agency.lead-machine-dashboard',
            isExpanded:false,
            icon: 'uil-apps',
            pathActive: 'lead-machine',
            type:'lead_machine',
            items:[
              {
                label: 'Dashboard',
                route: 'agency.lead-machine-dashboard',
                icon: 'uil-home',
                pathActive: '/agency/lead-machine/dashboard',
              },
              {
                label: 'Mailed Leads',
                route: 'agency.local-searches-mailed',
                icon: 'uil-envelope-open',
                pathActive: '/agency/lead-machine/local-search-mailed',
              },
              {
                label: 'Local Searches',
                route: 'agency.local-searches',
                icon: 'uil-book',
                pathActive: '/agency/lead-machine/local-searches',
              },
              {
                label: 'Letter Templates',
                route: 'agency.letter-templates',
                icon: 'uil-file-alt',
                pathActive: '/agency/lead-machine/letter-templates',
              },
              {
                label: 'Landing Pages',
                route: 'agency.le-landing-pages',
                icon: 'uil-window',
                pathActive: '/agency/lead-machine/landing-pages',
              },
              {
                label: 'Import',
                route: 'agency.lead-machine-upload',
                pathActive: '/agency/lead-machine/upload',
              }
            ]
          },
          {
            label: 'Training',
            icon: 'uil-life-ring',
            route: 'agency.training',
            pathActive: '/agency/training',
          },
          {
            label: 'Settings',
            route: 'agency.settings',
            icon: 'uil-cog',
            pathActive: '/agency/settings',
          },
          {
            label: 'Subscription',
            route: 'agency.subscription',
            icon: 'uil-invoice',
            pathActive: '/agency/subscription',
          },
        ],
        Business: [
          {
            label: 'Dashboard',
            route: 'new-business.dashboard',
            icon: 'uil-home',
            pathActive: '/new-business/dashboard',
          },
          {
            label: 'Reviews',
            route: 'new-business.reviews',
            icon: 'uil-star',
            pathActive: '/new-business/reviews',            
          },
          {
            label: 'Employees',
            route: 'new-business.employees',
            icon: 'uil-users-alt',
            pathActive: '/new-business/employees',
          },
          {
            label: 'Review Landing Page',
            route: 'new-business.review-landing-page',
            icon: 'uil-web-grid-alt',
            pathActive: '/new-business/review-landing-page',
          },
          {
            label: 'Review Images',
            route: 'new-business.review-images',
            icon: 'uil-image',
            pathActive: '/new-business/review-images',
          },
         
          {
            label: 'Review Surge',
            route: 'new-business.review-surge',
            icon: 'uil-file-alt',
            pathActive: '/new-business/review-surge',
          },
         
          {
            label: 'Review Sequence',
            route: 'new-business.review-sequence',
            icon: 'uil-comment',
            pathActive: '/new-business/review-sequence',
          },
          {
            label: 'Contacts',
            route: 'new-business.request-contacts',
            icon: 'uil-user-check',
            pathActive: '/new-business/request-contacts',
          },
          {
            label: 'Personalized Image',
            route: 'new-business.request-personalized-image',
            icon: 'uil-camera',
            pathActive: '/new-business/request-personalized-image',
          },
          {
            label: 'Review Widget',
            route: 'new-business.request-review-widget',
            icon: 'uil-desktop',
            pathActive: '/new-business/request-review-widget',
          },
          {
            label: 'Social Posts',
            route: 'new-business.social-posts',
            icon: 'uil-comment-alt',
            pathActive: '/new-business/social-posts',
          },
          {
            label: 'Instagram Widget',
            route: 'new-business.instagram-widget',
            icon: 'uil-instagram',
            pathActive: '/new-business/instagram-widget',
          },
          {
            label: 'Settings',
            route: 'new-business.settings',
            icon: 'uil-cog',
            pathActive: '/new-business/settings',
          }
        ],
      },
      currentRoute: '',
    }
  },

  computed: {
    isOnAgencyRoute() {
      const name = this.$route.name
      const path = this.$route.path
      return (
        (name && (String(name).startsWith('agency.') || String(name).startsWith('new-agency.'))) ||
        (path && path.startsWith('/agency/'))
      )
    },
    renderMenuItems() {
      if (this.user) {
        // When a Business user is on an agency route, show full agency sidebar (all agency menu items)
        if (this.user.role === 'Business' && this.isOnAgencyRoute) {
          return this.menuItems.Agency || []
        }
        let items = this.menuItems[this.user.role];
        if (this.user.role === 'Agency') {
          const replyEngineRoutes = ['agency.landing', 'agency.embed'];
          items = items.filter(
              (i) => !this.user.agency.free_fee ||
                  (this.user.agency.free_fee &&
                      i.label !== 'Payment methods')
          ).filter(item => {

            if (!this.user.agency.free_fee && !this.user.user_plans.filter(plan => {
              return plan.plan.product_type === 'ReplyEngine' && !plan.past_due
            }).length && replyEngineRoutes.includes(item.route)) {
              return false;
            } else {
              return true;
            }

          });
          // Remove Customers Link
          items = items.filter(
              (item) => {
                if ((item.route === 'agency.customers.index' || item.route === 'new-agency.customers.index') && !this.user.agency.free_fee && !this.user.has_review_requester && !this.user.has_re && !this.user.has_social_review && !this.user.has_te && !this.user.has_social_fusion && !this.user.has_insta_stream && !this.user.has_repu_agency) {
                  return false;
                } else {
                  return true;
                }
              });
          const socialReviewRoutes = ['agency.sr-widget'];
          items = items.filter(
              (item) => {
                if (!this.user.agency.free_fee && !this.user.user_plans.filter(plan => {
                  return plan.plan.product_type === 'SocialReview' && !plan.past_due
                }).length && socialReviewRoutes.includes(item.route)) {
                  return false;
                } else {
                  return true;
                }

              });

          const socialFusionRoutes = ['agency.sf-widget'];
          items = items.filter(
              (item) => {
                if (!this.user.agency.free_fee && !this.user.user_plans.filter(plan => {
                  return plan.plan.product_type === 'SocialFusion' && !plan.past_due
                }).length && socialFusionRoutes.includes(item.route)) {
                  return false;
                } else {
                  return true;
                }

              });
          const instaStreamRoutes = ['agency.instagram-widget.index', 'agency.insta-stream-widget'];
          items = items.filter(
              (item) => {
                if (!this.user.agency.free_fee && !this.user.user_plans.filter(plan => {
                  return plan.plan.product_type === 'InstaStream' && !plan.past_due
                }).length && instaStreamRoutes.includes(item.route)) {
                  return false;
                } else {
                  return true;
                }

              });


          const ReSrRoutes = ['agency.businesses.index', 'new-agency.businesses.index'];
          items = items.filter(
              (item) => {
                if (!this.user.agency.free_fee && !this.user.user_plans.filter(plan => {
                  return (plan.plan.product_type === 'SocialReview' || plan.plan.product_type === 'ReplyEngine' || plan.plan.product_type === 'ReviewSurge' || plan.plan.product_type === 'SocialFusion' || plan.plan.product_type === 'InstaStream') && !plan.past_due
                }).length && ReSrRoutes.includes(item.route)) {
                  return false;
                } else {
                  return true;
                }

              });

          // const leadMachineRoutes = ['agency.local-searches', 'agency.letter-templates','agency.lead-machine-dashboard','agency.local-searches-mailed','agency.le-landing-pages'];
          items = items.filter(
              (item) => {
                if (!this.user.agency.free_fee && !this.user.user_plans.filter(plan => {
                  return plan.plan.product_type === 'LeadMachine' && !plan.past_due
                }).length && item.type === 'lead_machine') {
                  return false;
                } else {
                  return true;
                }
              });

        }
        if (this.user.role === 'Business') {
          const tapEngineRoutes = ['new-business.dashboard', 'new-business.review-landing-page', 'new-business.employees', 'new-business.reviews', 'new-business.settings'];
          const socialReviewRoutes = ['new-business.dashboard', 'new-business.review-images', 'new-business.reviews', 'new-business.settings'];
          const socialFusionRoutes = ['new-business.social-posts', 'new-business.settings'];
          const textRequesterRoutes = ['new-business.dashboard', 'new-business.review-landing-page', 'new-business.review-surge', 'new-business.review-sequence', 'new-business.review-contact-series', 'new-business.review-gate', 'new-business.settings', 'new-business.reviews', 'new-business.request-contacts', 'new-business.employees', 'new-business.request-personalized-image', 'new-business.request-review-widget'];
          const replyEngineBusinessRoutes = ['new-business.dashboard', 'new-business.reviews', 'new-business.review-landing-page', 'new-business.settings'];
          const instagramWidgetRoutes = ['new-business.instagram-widget', 'new-business.settings'];
          const settingsRoute = ['new-business.settings'];
          const personalizedImageAndWidgetRoutes = ['new-business.request-personalized-image', 'new-business.request-review-widget'];
          items = items.filter((item) => {
            if (this.user.business) {
              if (this.user.business.is_tap_engine && tapEngineRoutes.includes(item.route) && (this.user.business.owner.has_te || this.user.business.owner.has_repu_agency || this.user.business.owner.agency.free_fee)) {
                return true;
              }
              if (this.user.business.is_social_fusion && socialFusionRoutes.includes(item.route) && (this.user.business.owner.has_social_fusion || this.user.business.owner.has_repu_agency || this.user.business.owner.agency.free_fee)) {
                return true;
              }
              if (this.user.business.is_social_review && socialReviewRoutes.includes(item.route) && (this.user.business.owner.has_social_review || this.user.business.owner.has_repu_agency || this.user.business.owner.agency.free_fee)) {
                return true;
              }
              if (this.user.business.is_text_requester && textRequesterRoutes.includes(item.route) && (this.user.business.owner.has_review_requester || this.user.business.owner.has_repu_agency || this.user.business.owner.agency.free_fee)) {
                return true;
              }
              if (this.user.business.is_reply_engine && replyEngineBusinessRoutes.includes(item.route) && (this.user.business.owner.has_re || this.user.business.owner.has_repu_agency || this.user.business.owner.agency.free_fee)) {
                return true;
              }
              if (this.user.business.is_insta_stream && instagramWidgetRoutes.includes(item.route) && (this.user.business.owner.has_insta_stream || this.user.business.owner.has_repu_agency || this.user.business.owner.agency.free_fee)) {
                return true;
              }
              if((this.user.business.is_insta_stream || this.user.business.is_reply_engine || this.user.business.is_tap_engine || this.user.business.is_social_fusion || this.user.business.is_social_review || this.user.business.is_text_requester) && settingsRoute.includes(item.route)){
                return true;
              }
              // Allow Personalized Image and Review Widget for any business with any product type
              if((this.user.business.is_insta_stream || this.user.business.is_reply_engine || this.user.business.is_tap_engine || this.user.business.is_social_fusion || this.user.business.is_social_review || this.user.business.is_text_requester) && personalizedImageAndWidgetRoutes.includes(item.route)){
                return true;
              }
              return false;
            } else if ([...tapEngineRoutes, ...socialReviewRoutes, ...textRequesterRoutes, ...replyEngineBusinessRoutes, ...socialFusionRoutes, ...instagramWidgetRoutes, ...settingsRoute].includes(item.route)) {
              return false;
            }
          });
        }

        return items
      }
      return []
    },

    isImpersonating() {
      return this.$store.getters['auth/isImpersonating']
    },

    showNotification() {
      return this.userRole === 'Agency'
    },

    userRole() {
      return this.user ? this.user.role : ''
    },

    user() {
      return this.$store.getters['auth/user']
    },

    config() {
      return this.$store.getters['app/config']
    },

    routeName(){
      return this.$route.name;
    },

    agencyForBranding() {
      if (!this.user) return null
      if (this.user.role === 'Agency' && this.user.agency) {
        return this.user.agency
      }
      if (this.user.role === 'Business' && this.user.business) {
        return this.user.business.owner?.agency || this.user.business.agency || null
      }
      return null
    },

    sidebarBrandLogo() {
      if (this.config?.logo) {
        return this.config.logo
      }
      const whitelabel = this.agencyForBranding?.whitelabel
      return whitelabel?.header_logo || null
    },

    displayName() {
      if (!this.user) return ''
      if (this.config?.name) {
        return this.config.name
      }
      const agency = this.agencyForBranding
      if (agency?.name) {
        return agency.name
      }
      return this.user.full_name || ''
    },
  },

  mounted() {
    if (this.isLeadMachine) {
      document.body.classList.add('lm-variation')
    }
    this.currentRoute = this.$router.currentRoute.path

    this.$router.afterEach((to, from) => {
      this.currentRoute = to.path
    })
  },

  methods: {
    clickParentItem(menuItem) {
      menuItem.isExpanded = !menuItem.isExpanded;
    },
    stopImpersonate() {
      this.loadingStopImpersonate = true

      this.$store
          .dispatch('auth/stopImpersonate')
          .then(() => {
            this.$store
                .dispatch('auth/getProfile')
                .then((user) => {
                  this.$router.push('/' + this.userRole.toLocaleLowerCase())
                  this.loadingStopImpersonate = false
                })
                .catch(() => {
                  this.loadingStopImpersonate = false
                })
          })
          .catch(() => {
            this.loadingStopImpersonate = false
          })
    },

    logout() {
      this.$store
          .dispatch('auth/logout')
          .then(() => {
            this.$router.push({name: 'login'})
          })
          .catch(() => {
          })
    },
  },
}
</script>
<style lang="scss" scoped>

.slimscroll-menu {
  height: 100%;
}
.ps > .ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
  width: 6px !important;
}
.icon-round {
    border-radius: 0.45rem;
    padding: 3px;
}
#sidebar-menu > ul > li.mm-active > a > .icon-round {
    background-color: #4282ff;
}
.metismenu {
    padding: 0 10px 0 10px;
}
.left-side-menu {
  top: 0px;
  padding-bottom: 0px !important;
  background-color: #e1e7ef;
  border-right: 1px solid #dddddd !important;

  a.navbar-brand.logo {
    display: block;
    max-width: 100%;
    box-sizing: border-box;

    > .flex {
      align-items: center;
      max-width: 100%;
      min-width: 0;
    }

    // Uploaded agency logo (no name heading beside it)
    > .flex:not(:has(h4)) {
      flex-direction: column;
      align-items: stretch;

      .logo-sm {
        width: 100%;
        height: auto;
        flex-shrink: 0;
        display: block;
        padding: 12px 12px 6px;
        line-height: 0;

        img {
          display: block;
          width: 100%;
          max-width: 100%;
          height: auto;
          object-fit: contain;
          object-position: center;
        }
      }

      .ml-2 {
        width: 100%;
        flex: none;
        margin-left: 0 !important;
        text-align: center;
        padding: 0 12px 8px;
      }
    }

    // Default favicon + agency name
    > .flex:has(h4) .logo-sm {
      flex-shrink: 0;
      display: flex;
      align-items: center;

      img {
        display: block;
        height: 50px;
        width: auto;
        max-width: 50px;
        object-fit: contain;
      }
    }

    .ml-2 {
      min-width: 0;
      overflow: hidden;
      flex: 1;

      h4 {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: normal;
        word-break: break-word;
        line-height: 1.2;
      }

      p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  a.side-nav-link {
    i,
    svg.icon-round {
      margin-right: 20px !important;
    }
  }
}
#side-menu {
  max-height: calc(100vh - 140px);
  overflow-y: auto;
}
#sidebar-menu > ul > li {
  padding: 4px 0px;
}
#sidebar-menu > ul > li > a {
  color: gray;
  padding: 8px;
}
#sidebar-menu a:hover {
    color: #292929;
    background-color: #f4f5f680;
    border-radius: 0.75rem !important;
    cursor: pointer !important;
}
#sidebar-menu > ul > li.mm-active > a {
    color: #ffffff;
    background-color: #0055ff !important;
    border-left: 3px solid transparent;
    border-radius: 0.75rem;
}
.left-side-menu .sidebar-content {
  height: 100% !important;
  display: flex;
  flex-direction: column;
  padding-bottom: 0px;
}
#sidebar-menu {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-bottom: 0px;
}
.sidebar-bottom {
  margin-top: auto; // pushes this div to the bottom
}
.mm-active, .nav-second, .nav-second-level{
  background: #e1e7ef;
}
.nav-second-level{
  border-bottom: 2px solid #112144;
}
.light-variation{
  .mm-active, .nav-second, .nav-second-level{
    background: #c2bfbf;
    a{
      color: #2c2e2f;
    }
    a.router-link-active{
      color: #c2bfbf;
    }
  }
  .nav-second-level{
    border-bottom: 2px solid #c2bfbf;
  }
}
</style>
